import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import ScrollToTop from 'react-scroll-up'
import Fade from 'react-reveal/Fade'

import egypt from '../assets/images/egypt.jpg'
import scroll from '../assets/images/scroll.svg'
import footprints from '../assets/images/footprints.svg'
import earth from '../assets/images/earth.svg'
import maternity from '../assets/images/maternity.svg'
import book from '../assets/images/book.svg'
import arrow from '../assets/images/arrow.svg'

const Qui = (props) => (
  <div>
    <Helmet>
      <html lang="fr" />
      <title>La réflexologie</title>
      <meta name="description" content="au sujet de la réflexologie" />
    </Helmet>

    <div id="main" className="alt">
      <section id="one">
        <div className="inner">
          <header className="major">
            <h1>La réflexologie</h1>
          </header>
          <hr></hr>
          <Fade>
            <span className="img main">
              <img src={scroll} alt="icone de parchemin" />
            </span>
            <h2>Histoire</h2>
            <p>
              Plusieurs fois millénaire, elle trouve ses origines dans de
              nombreuses civilisations. En Chine, en Egypte, en Inde, et en
              Occident. Le document le plus ancien concernant la réflexologie
              plantaire a été trouvé en Egypte à l'entrée d'un tombeau à
              Sakkarah. Il s'agit d'un pictogramme datant de 2330 av. J.C. Sur
              lequel sont représentées des personnes se manipulant les pieds et
              les mains. Les hiéroglyphes signifieraient "Ne me fais pas mal" et
              le praticien répondrait "Je ferai en sorte que tu me remercies.".
            </p>
            <span className="image main">
              <img src={egypt} alt="une peinture egyptienne" />
            </span>
            <p>
              En Amérique, pour les Incas, les massages étaient considérés comme
              un art sacré, les pieds symbolisant la partie du corps qui relie
              l'homme à l'univers et aux esprits. Les tribus Indiennes
              reconnaissaient les vertus des massages sur l'équilibre mental,
              physique et spirituel.
            </p>
            <p>
              En Europe, au XIX siècle, plusieurs chercheurs médecins se sont
              concentrés sur le fait qu'une stimulation d'une partie du corps
              agissait sur une partie éloignée.
            </p>
            <p>
              Aux Etats-Unis, le Dr Fitzgerald (1872-1942) développe des "points
              de pressions". Lors de ses recherches, il constate que non
              seulement la pression soulage la douleur, mais une fois la douleur
              disparue, la condition qui la provoquait est souvent améliorée.
            </p>
            <p>
              Puis en 1926 Eunice Ingham, considérée comme la mère de la
              réflexologie plantaire, par son travail sur des milliers de pieds,
              vérifia l'emplacement des points douloureux et les symptômes. Elle
              mit au point une cartographie précise de mise en relation des
              points sensibles du pied avec l'anatomie de l'organisme.
            </p>
            <p>
              <i>
                source : manuel approfondi de réflexologie plantaire de Mireille
                Meunier
              </i>
            </p>
            <hr></hr>
            <span className="img main">
              <img src={footprints} alt="icone de parchemin" />
            </span>
            <h2>Qu'est-ce que la Réflexologie ?</h2>
            <p>
              La Réflexologie est une technique manuelle, qui permet dans un
              premier temps une détente, un bien-être, puis elle va stimuler le
              principe d'autorégulation du corps et permettre un rééquilibre,
            </p>
            <p>
              <em>"L' Intelligence du corps !"</em>
            </p>
            <p>
              Le pied est l'hologramme de notre corps. Il regroupe 7200
              terminaisons nerveuses. Le réflexologue va stimuler des Zones
              Réflexes qui sont en correspondance avec les organes et systèmes
              du corps. Ainsi il envoie une information au cerveau, qui
              naturellement va l'intégrer et réagir.
            </p>
            <p>
              Cette technique est complémentaire à la médecine conventionnelle.
            </p>
            <hr></hr>
            <span className="img main">
              <img src={earth} alt="icone d'un globe'" />
            </span>
            <h2>Pourquoi la Réflexologie Intégrative ?</h2>
            <p>
              La Réflexologie Intégrative intègre des techniques et des
              philosophies occidentales et orientales. Elle permet d'avoir une
              approche de l'être dans sa globalité physique, émotionnelle et
              spirituelle. C'est une approche dite "globale".
            </p>
            <p>
              Je vous accompagne vers une nouvelle dynamique, mes stimulations
              mobilisent le principe d'autorégulation du corps , c'est vous
              seule qui avez la réponse et de vous-même, vous irez vers une
              adaptation entre ce que vous êtes et ce que vous vivez.!
            </p>
            <hr></hr>
            <span className="img main">
              <img src={maternity} alt="icone d'une femme enceinte" />
            </span>
            <h2>La réflexologie périnatale</h2>
            <div className="row">
              <div className="6u 12u$(small)">
                <p>
                  Du désir de grossesse à la naissance, avec cette technique
                  spécifique, je vous accompagne afin que tout se passe au
                  mieux, et cela va bien au-delà ! Il s'agit d'un accompagnement
                  organique, physique, énergétique et émotionnel.
                </p>
                <p>
                  La réflexologie peut être un soutien en cas d'infertilité, en
                  réduisant le stress et les tensions émotionnelles.
                </p>
              </div>
              <div className="6u 12u$(small)">
                <p>
                  La réflexologie permet à la maman de vivre sa grossesse dans
                  les meilleures conditions physiques, à gérer son stress et ses
                  émotions face au grand événement qui l'attend. Après l'accouc
                  hement, elle va aider le corps à retrouver un équilibre
                  naturel. Retrouver dynamisme et vitalité.
                </p>
                <p>Future maman c'est le moment de prendre soin de vous !</p>
              </div>
            </div>
            <hr></hr>
            <span className="img main">
              <img src={book} alt="icone d'un livre" />
            </span>
            <h2>Déontologie du réflexologue</h2>
            <h4> Le réflexologue ... </h4>
            <ol>
              <li>
                Adhère à la définition de la Réflexologie retenue par la
                Fédération Française des Réflexologues.
              </li>
              <li>
                Admis comme membre de la Fédération, s’engage à exercer son
                activité avec humanité, probité et loyauté.
              </li>
              <li>
                S’engage à toujours observer le principe fondamental du respect
                de la personne humaine.
              </li>
              <li>
                Membre de la Fédération, s’engage à ne nuire en aucune façon à
                celle-ci ou à l’un de ses membres ; il y fait preuve d’esprit
                confraternel, d’entraide à l’égard des autres membres de la
                Fédération.
              </li>
              <li>
                A pour objectif de restaurer au maximum l’autonomie de son
                client.
              </li>
              <li>
                Ne pose aucun diagnostic médical et n’intervient dans aucune
                décision thérapeutique.
              </li>
              <li>
                Observe l’attitude absolue de réserve et de secret professionnel
                pour tous ses clients.
              </li>
              <li>
                A tout moment laisse à son client sa totale liberté de choix
                thérapeutique.
              </li>
              <li>
                S’attache à promouvoir, sous l’égide de la Fédération, les
                standards de formation retenus par la FFR pour satisfaire les
                critères et exigences de la profession et s’engage à parfaire sa
                pratique en participant à des formations post graduées.
              </li>
              <li>
                S’engage à n’émettre aucune critique à l’égard d’un membre ou
                d’une formation reconnue par la Fédération.
              </li>
              <li>
                A respecter son client dans sa demande et ses choix de vie.
              </li>
              <li>
                A ne cautionner ni alimenter les excès, errances (émotionnelles,
                spirituelles, addictions, dérives perverses) ou projections de
                son client, afin de demeurer authentique dans la démarche
                stricte et exclusive du réflexologue qui n’est ni un médecin, ni
                un maître spirituel, ni un substitut affectif.
              </li>
            </ol>
          </Fade>
          <ScrollToTop showUnder={160}>
            <span className="img main">
              <img src={arrow} alt="icone fleche" />
            </span>
          </ScrollToTop>
        </div>
      </section>
    </div>
  </div>
)

export default Qui



// WEBPACK FOOTER //
// ./src/pages/reflexologie.js